import i18n from 'modules/core/lib/i18n'

export const DEFAULT_ASSIGNMENT_PERCENTAGE = -1
export const DEFAULT_ASSIGNMENT_COST_CENTER_ID = -1

export const defaultAssignment = ({
  startDate,
  endDate,
  previousCostCenterId,
}: {
  startDate: string
  endDate?: string
  previousCostCenterId: number
}) => {
  // As we're allowing to create bulk assignments, we need to assign the previous cost center id
  // to the new assignment to avoid overlapping assignments.
  const idToAssign =
    previousCostCenterId >= 0 ? DEFAULT_ASSIGNMENT_COST_CENTER_ID : previousCostCenterId - 1

  return {
    id: String(idToAssign),
    name: i18n.t('finance.cost_centers.assignments.editable_card.select'),
    percentage: DEFAULT_ASSIGNMENT_PERCENTAGE,
    startDate,
    endDate,
    costCenterId: idToAssign,
  }
}

let structuredAssignmentCounter = -1

export const defaultStructuredAssignment = ({
  startDate,
  endDate,
}: {
  startDate: string
  endDate?: string
}) => {
  // Use a decrementing counter to create unique IDs for new structured assignments
  const uniqueId = structuredAssignmentCounter--

  return {
    id: String(uniqueId),
    name: i18n.t('finance.cost_centers.assignments.editable_card.select'),
    percentage: DEFAULT_ASSIGNMENT_PERCENTAGE,
    startDate,
    endDate,
    costCenterId: undefined,
    jobCatalogCostCenterId: undefined,
    jobCatalogNodeUuid: undefined,
    workplaceCostCenterId: undefined,
    workplaceId: undefined,
  }
}

const resetStructuredAssignmentCounter = () => {
  structuredAssignmentCounter = -1
}
